import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const DropdownWrapper = styled.div`
  display: flex;
  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent} !important;
    `}
`;

export const DropdownContainer = styled.div`
  position: relative;
  width: ${(props) => (props.width ? props.width : '155px')};
  height: 37px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  background: ${colors.white};
  margin: ${(props) => (props.margin ? props.margin : '0')};

  ${(props) =>
    props.fillAndCenter &&
    css`
      width: 100%;
      height: 30px;
      border-radius: 0px;
      margin-top: 1px;
    `}

  :after {
    position: absolute;
    top: 4px;
    right: 10px;
    content: '\f0d7';
    font-family: FontAwesome;
    color: ${colors.darkGray};
    margin-left: 5px;
    pointer-events: none;
  }
  :focus-within {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  }
`;

export const DropdownInput = styled.select`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  appearance: none;
  background: transparent;
  padding: 3px 8px;
  font-size: 16px;
  height: 100%;
  color: ${colors.darkGray};
  border: none;
  width: 100%;
  outline: none;

  ${(props) =>
    props.fillAndCenter &&
    css`
      color: ${colors.darkBlue} !important;
      font-weight: 600;
      font-size: 14px;
      text-align: center;
      background: rgba(0, 0, 0, 0.1);
    `}
`;
